/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconCircleLetterT = createReactComponent("outline", "circle-letter-t", "IconCircleLetterT", [["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-0" }], ["path", { "d": "M10 8h4", "key": "svg-1" }], ["path", { "d": "M12 8v8", "key": "svg-2" }]]);

export { IconCircleLetterT as default };
//# sourceMappingURL=IconCircleLetterT.mjs.map
